// extracted by mini-css-extract-plugin
module.exports = {"root":"tabs_root__3qHUi","animateRoot":"tabs_animateRoot__2Ivl-"};